import React, { useState } from 'react';
import SystemArchitectureDiagram from './diagrams/SystemArchitectureDiagram';
import DeploymentArchitectureDiagram from './diagrams/DeploymentArchitectureDiagram';
import NetworkArchitectureDiagram from './diagrams/NetworkArchitectureDiagram';
import SecurityArchitectureDiagram from './diagrams/SecurityArchitectureDiagram';
import ModulesArchitectureDiagram from './diagrams/ModulesArchitectureDiagram';

const SystemArchitecture: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('system');
  
  const tabs = [
    { id: 'system', label: '系统架构' },
    { id: 'deployment', label: '部署架构' },
    { id: 'network', label: '网络架构' },
    { id: 'security', label: '安全架构' },
    { id: 'modules', label: '功能模块' },
  ];
  
  return (
    <div className="p-4 max-w-7xl mx-auto mt-4">
      <h1 className="text-3xl font-bold text-center text-gray-800 mb-8">
        系统架构设计
      </h1>
      
      {/* Tab Navigation */}
      <div className="flex flex-wrap justify-center mb-6 border-b border-gray-200">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`py-3 px-6 font-medium text-lg transition-colors duration-200 ${
              activeTab === tab.id
                ? 'text-blue-600 border-b-2 border-blue-600'
                : 'text-gray-500 hover:text-blue-500'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      {/* Content */}
      <div className="mt-6">
        {activeTab === 'system' && <SystemArchitectureDiagram />}
        {activeTab === 'deployment' && <DeploymentArchitectureDiagram />}
        {activeTab === 'network' && <NetworkArchitectureDiagram />}
        {activeTab === 'security' && <SecurityArchitectureDiagram />}
        {activeTab === 'modules' && <ModulesArchitectureDiagram />}
      </div>
    </div>
  );
};

export default SystemArchitecture; 